import module from 'empresa/module.js'

export const schema = {}

export default class EmpresaCuentaDocumentosService {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, idCuenta) {
    return this.$http.get('/api/empresa/cuenta/documentos', {
      params: {
        id_empresa: idEmpresa,
        id_cuenta: idCuenta,
      },
      schema,
    })
  }

  post (idEmpresa, idCuenta, data) {
    let formData = new FormData()
    formData.set('id_tipo_documento', data.id_tipo_documento)
    formData.set('file', data.file)

    return this.$http.post('/api/empresa/cuenta/documentos', formData, {
      params: {
        id_empresa: idEmpresa,
        id_cuenta: idCuenta,
      },
    })
  }
}

module.service('EmpresaCuentaDocumentos', EmpresaCuentaDocumentosService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Cuenta/Documentos.js